import $ from 'jquery';
import { getRequestVerificationToken } from '../utility/ajax-helpers';
import $hub from '../utility/events-hub';

import favStore from './favorite-store';


/**
 * TODO NIJE:
 * get dynamic endpoints from viewModel
 * Get IsFavoriteStore from API
 * Get dictionary items
 */

const opts = {
    storeStockListAddToFavoriteTrigger: '.js-store-stock-list-add-to-favorite-trigger',
    storeStockListRemoveFromFavoriteTrigger: '.js-store-stock-list-remove-from-favorite-trigger',
    storeStockListTrigger: '.js-store-stock-list-trigger',
    storeStockListError: '.js-store-stock-list-error',
    storeStockListPlaceholder: '.js-store-stock-list-placeholder',

    addToFavoriteButtonTemplate: (isFavoriteStore, StoreId, addToFavoriteStoreApi, addToFavoriteStoreLabel) => {
        return `
            <button class="link-button js-store-stock-list-add-to-favorite-trigger ${isFavoriteStore ? 'u-hidden' : ''}" type="button" data-reload="true" data-store="${StoreId}" data-url="${addToFavoriteStoreApi}" data-method="POST">
                ${addToFavoriteStoreLabel}
            </button>
        `;
    },

    removeFromFavoriteButtonTemplate: (isFavoriteStore, removeFromFavoriteStoreApi, removeFromFavoriteStoreLabel) => {
        return `
            <button class="link-button js-store-stock-list-remove-from-favorite-trigger ${isFavoriteStore ? '' : 'u-hidden'}" data-reload="true" type="button" data-url="${removeFromFavoriteStoreApi}" data-method="DELETE">
                ${removeFromFavoriteStoreLabel}
            </button>
        `;
    },

    rowTemplate: ({ name, address, zip, city, stock, piecesLabel, color, storeId, isB2B, isFavoriteStore, addToFavoriteStoreLabel, removeFromFavoriteStoreLabel, addToFavoriteStoreApi, removeFromFavoriteStoreApi, statusLabel}) => {
        if (isB2B) {
            return `
                <tr>
                    <td class="product-stock-store">
                        <b>${name}</b>
                        <br>
                        ${address}, ${zip} ${city}
                        <br>
                        ${!isFavoriteStore ? opts.addToFavoriteButtonTemplate(isFavoriteStore, storeId, addToFavoriteStoreApi, addToFavoriteStoreLabel) : ''}
                        ${isFavoriteStore ? opts.removeFromFavoriteButtonTemplate(isFavoriteStore, removeFromFavoriteStoreApi, removeFromFavoriteStoreLabel) : ''}
                    </td>
                    <td class="product-stock-amount">
                        ${stock} ${piecesLabel}
                    </td>
                </tr>
            `;
        } else {
            return `
            <tr>
                <td class="product-stock-store">
                    <b>${name}</b>
                    <br>
                    ${address}, ${zip} ${city}
                </td>
                <td class="text-right">
                    <span class="product-stock-label bg-${color}"></span>
                </td>
                <td class="text-left">
                    ${statusLabel}
                </td>
            </tr>
        `;
        }
    }
};

const bindEvents = ($modal) => {
    $modal.find(opts.storeStockListAddToFavoriteTrigger).on('click', (event) => {
        $hub.publish($hub.event.storeSelected, { event });
    });


    $modal.find(opts.storeStockListRemoveFromFavoriteTrigger).on('click', (event) => {
        favStore.removeFavoriteStore(event); // Somehow the removeFavoriteStore  method is not implemented to work with the event Hub thus calling it directly.
    });
};

const populateStoreStockList = (evt) => {
    evt.preventDefault();
    const $btn = $(evt.currentTarget);
    const $error = $(opts.storeStockListError);
    const $modal =  $($btn.attr('href'));

    const isB2B = $btn.data('isb2b');
    const addToFavoriteStoreApi = $btn.data('addtofavoritestoreapi');
    const addToFavoriteStoreLabel = $btn.data('addtofavoritestorelabel');
    const removeFromFavoriteStoreApi = $btn.data('removefromfavoritestoreapi');
    const removeFromFavoriteStoreLabel = $btn.data('removefromfavoritestorelabel');

    $modal.addClass('loading');
    $.fancybox.open({ src: $btn.attr('href'), touch: false });

    const params = {
        url: $btn.data('url'),
        type: $btn.data('method'),
        data: {
            variantcode: $btn.data('variantcode'),
            companyid: $btn.data('companyid'),
            storecountryroot: $btn.data('storecountryroot'),
            languagecode: $btn.data('languagecode')
        },
        headers: {
            ...getRequestVerificationToken
        }
    };

    $.ajax(params)
        .done((response) => {
            $error.text('');
            if (response.Success) {
                let storeStocks = '';
                // Update stores info
                response.StoreStockList.forEach((storeStock) => {

                    const storeData = {
                        name: storeStock.StoreName,
                        address: storeStock.StoreAddress,
                        zip: storeStock.StoreZip,
                        city: storeStock.StoreCity,
                        stock: storeStock.Stock,
                        piecesLabel: storeStock.PiecesLabel,
                        color: storeStock.StockStatus,
                        storeId: storeStock.StoreId,
                        isB2B,
                        isFavoriteStore: storeStock.IsFavoriteStore,
                        addToFavoriteStoreApi,
                        addToFavoriteStoreLabel,
                        removeFromFavoriteStoreApi,
                        removeFromFavoriteStoreLabel,
                        statusLabel: storeStock.StatusLabel
                    };

                    storeStocks += opts.rowTemplate(storeData);
                });

                $(opts.storeStockListPlaceholder).html(storeStocks);

                bindEvents($modal);

            } else {
                $error.text(`${response.ErrorMessage}`).show();
            }
        })
        .fail((error) => {
            $error.text(`${error.status} - ${error.statusText}`).show();
        })
        .always(() => {
            $modal.removeClass('loading');
        });
};

const init = ($elm) => {
    const $btn = $elm ? $elm.find(opts.storeStockListTrigger) : $(opts.storeStockListTrigger);

    if (!$btn.length) return;

    $hub.subscribe($hub.event.storeSelected, favStore.addFavoriteStore);

    $btn.on('click', populateStoreStockList);
};

export default {
    init
};
